import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShoppingBagAdd2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconShoppingBagAdd2"><Path d="M15.25 7.75V6C15.25 4.20507 13.7949 2.75 12 2.75C10.2051 2.75 8.74998 4.20507 8.74998 6V7.75M12.25 21.25H7.72716C5.89525 21.25 4.49109 19.6225 4.75955 17.8104L5.87066 10.3104C6.08859 8.83936 7.35122 7.75 8.83827 7.75H15.1617C16.6487 7.75 17.9114 8.83936 18.1293 10.3104L18.5278 13M18.25 16.25V19.25M18.25 19.25V22.25M18.25 19.25H15.25M18.25 19.25H21.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconShoppingBagAdd2;
